import { CoreUIProvider } from '@eleo-rh/core-ui'
import { useI18n } from 'context/I18nProvider'
import type { PropsWithChildren } from 'react'

const langMap = {
  de: 'de',
  en: 'en-gb',
  fr: 'fr',
} as const

export default function CoreUIProviderAdapter({ children }: PropsWithChildren) {
  const { locale } = useI18n()

  return (
    <CoreUIProvider
      lang={langMap[locale as keyof typeof langMap] ?? 'fr'}
      module="eleo"
      theme={{
        components: {
          Select: {
            colorText: 'var(--color-slate-600)',
          },
        },
      }}
    >
      {children}
    </CoreUIProvider>
  )
}
